// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"6250eacd","237":"103f1b11"}[chunkId] + ".chunk.css";
};